import React from "react";
import { useTranslation } from "react-i18next";
import { emailPattern, getTranslatedLabel } from "../../../utils/helpers";
import ButtonsRadioRHF from "../RHF/ButtonsRadioRHF";
import DatePickerInputRHF from "../RHF/DatePickerInputRHF";
import TitleModal from "../titleModal";
import TextParagraph from "../textParagraph";
import SwitchRHF from "../RHF/SwitchRHF";
import SelectBoxRHF from "../RHF/SelectBoxRHF";
import InputFiledRHF from "../RHF/inputFiledRHF";
import TextareaRHF from "../RHF/textareaRHF";
import FiscalCodeInputFieldRHF from "../RHF/fiscalCodeInputFieldRHF";

// Component starts
const DynamicForm = ({ ...props }) => {
  const { t } = useTranslation();

  /**
   * de-structure props.
   */
  const { formField, register, errors } = props;
  const { name, required, type, setValue } = formField;
  const fieldLabel = getTranslatedLabel(formField.translations);

  /**
   * returns field text label.
   */
  const getFieldLabel = () => {
    return (
      <label className={`ms-2 label-sm ${errors[name] ? "text-danger" : ""}`}>
        {fieldLabel} {required ? "*" : ""}
      </label>
    );
  };

  /**
   * returns boolean field text label.
   */
  const getBooleanFieldLabel = () => {
    return (
      <div className={`ms-2 mt-1 label-sm ${errors[name] ? "text-danger" : ""}`}>
        <label dangerouslySetInnerHTML={{ __html: fieldLabel }} />
        <span>{required ? "*" : ""}</span>
      </div>
    );
  };

  switch (type) {
    case "text":
      return (
        <>
          {getFieldLabel()}
          <div className="mb-2">
            <InputFiledRHF
              {...props}
              register={{
                ...register(name, {
                  required: required,
                }),
              }}
            />
          </div>
        </>
      );

    case "email":
      return (
        <>
          {getFieldLabel()}
          <div className="mb-2">
            <InputFiledRHF
              {...props}
              register={{
                ...register(name, {
                  required: required,
                  pattern: {
                    value: emailPattern(),
                    message: t("dynamic-form.invalid-email"),
                  },
                }),
              }}
            />
          </div>
        </>
      );

    case "title":
      return <TitleModal title={fieldLabel} />;

    case "paragraph":
      return <TextParagraph title={fieldLabel} />;

    case "radio":
      return (
        <>
          {getFieldLabel()}
          <ButtonsRadioRHF
            {...props}
            register={{
              ...register(name, {
                required: required,
              }),
            }}
          />
        </>
      );

    case "date":
    case "day":
      return (
        <>
          {getFieldLabel()}
          <DatePickerInputRHF
            {...props}
            register={{
              ...register(name, {
                required: required,
              }),
            }}
          />
        </>
      );

    case "longtext":
      return (
        <>
          {getFieldLabel()}
          <TextareaRHF
            {...props}
            register={{
              ...register(name, {
                required: required,
              }),
            }}
          />
        </>
      );

    case "boolean":
      return (
        <>
          <SwitchRHF
            {...props}
            label={getBooleanFieldLabel()}
            register={{
              ...register(name, {
                required: required,
              }),
            }}
          />
        </>
      );

    case "select":
      return (
        <>
          {getFieldLabel()}
          <SelectBoxRHF
            {...props}
            register={{
              ...register(name, {
                required: required,
              }),
            }}
          />
        </>
      );
    case "fiscalCode":
      return (
        <>
          {getFieldLabel()}
          <FiscalCodeInputFieldRHF {...props} />
        </>
      );
  }
  return null;
};

export default DynamicForm;
